<div class="alert-popup-container">

  <!-- Header -->
  <div class="alert-popup-header">
    <div class="alert-headerline-left">
      <span class="title">Notificaties</span>
    </div>
    <div class="alert-headerline-right">
      <button mat-icon-button routerLink="/alerts" class="alert-header-icon">
        <mat-icon class="alert-popup-icon" color="primary" matTooltip="Melding instellingen">settings</mat-icon>
      </button>

      <button mat-icon-button routerLink="/alerts" class="alert-header-icon">
        <mat-icon class="alert-popup-icon" color="primary" matTooltip="Alle Notificaties Weergeven">list_alt</mat-icon>
      </button>
    </div>
    <div style="clear: both;"></div>
  </div>

  @if (loading) {
    <div class="loading-message">
      <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
    </div>
  }

  <!-- Notification List -->
  @if (!loading) {
    <div class="alert-popup-notifications content">
      @if (!alerts) {
        <div class="no-alerts-container">
          <mat-icon class="no-alerts-icon">notifications_none</mat-icon>
          <h3>How unfortunate</h3>
          <div>You have no new messages at the moment.</div>
          <small>Check back later or subscribe to more sources to recieve some!</small>
        </div>
      }
      @if (alerts) {
        <mat-nav-list dense>
          @for (alert of alerts; track alert) {
            <mat-list-item [routerLink]="['/alerts/detail', alert.id]" class="alerts-popup-list-item">
              <mat-icon matListItemIcon [style.color]="getColor(alert)">{{getIcon(alert)}}</mat-icon>
              <div matListItemTitle class="alert-popup-firstline">
                <span class="alert-popup-title">{{alert.title}}</span>
                <span class="alert-date">{{alert.date | timeAgo}}</span>
                <div style="clear: both;"></div>
              </div>
              <p matListItemLine>
                <span> {{alert.message}} </span>
              </p>
            </mat-list-item>
          }
        </mat-nav-list>
      }
    </div>
  }
</div>